var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: 12,
            "form-context": _vm.formContext,
            icon: "inticon-users",
            title: "Externe Dienstleister",
          },
          on: { save: _vm.saveExternalProvidersFormData },
        },
        [
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Logistiker",
                  "options-loader": _vm.loadLogisticianOptions,
                  property: "logistician",
                  type: "autocomplete",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "KARO-Lack",
                  "options-loader": _vm.loadPaintShopOptions,
                  property: "paintShop",
                  type: "autocomplete",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Aufbereiter",
                  "options-loader": _vm.loadDetailerOptions,
                  property: "detailer",
                  type: "autocomplete",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "float-right" },
            [
              _c(
                "b-button",
                { attrs: { href: _vm.getQrLink(), variant: "primary" } },
                [
                  _c("i", {
                    staticClass: "inticon-autoclaim_einzeldownload_blue",
                  }),
                  _vm._v(" QR Code Dienstleisterdokumentation\n        "),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "clear-float" }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }